import { createFileRoute, redirect } from "@tanstack/react-router";

import { orgUrlSegment } from "../orgRouting";
import { readLastPickedOrgId } from "../state/orgs";

/**
 * The org-less usage path, kept only as a redirector for old links.
 *
 * Usage is read per organization, so there is no such thing as usage outside a
 * tenant: a session with a known organization lands on `/$org/usage`, and one
 * without has nothing to scope the figures to, so it falls back to the chat
 * root to pick an organization first.
 */
export const Route = createFileRoute("/usage")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
    const lastPickedOrgId = readLastPickedOrgId();
    if (!lastPickedOrgId) {
      throw redirect({ to: "/", replace: true });
    }
    throw redirect({
      to: "/$org/usage",
      params: { org: orgUrlSegment(lastPickedOrgId) },
      replace: true,
    });
  },
});
